import { render, staticRenderFns } from "./AuthorToolbar.vue?vue&type=template&id=0f25547e&scoped=true"
import script from "./AuthorToolbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuthorToolbar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AuthorToolbar.vue?vue&type=style&index=0&id=0f25547e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f25547e",
  null
  
)

export default component.exports